const ArchiveHellscapeRadioStatic = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/Oa17vu2-w2E" title="Hellscape Radio Vol. 6" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio Vol. 6</strong><br/>
            Hellscape Digital @ CRACKFEST 6 (Full Set)
            </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/21VuClIGW4o" title="Hellscape Radio Vol. 5" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio Vol. 5</strong><br/>
            Kawaii Ry @ CRACKFEST V (Full Set)
            </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/444jIQF-mRU" title="Hellscape Radio, Vol. 4" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio Vol. 4</strong><br/>Kawaii Ry & ANJU Online! @ CG Fest 2023
            </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/kXeKwQsEtg4" title="Hellscape Radio, Vol. 3 (Hosted by ANJU Online!)" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio Vol. 3</strong><br/>
            (Hosted by ANJU Online!)
            </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/WP598fnjOMM" title="Hellscape Radio, Vol. 2 (Hosted by ANJU Online!)" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio Vol. 2</strong><br/>
            (Hosted by ANJU Online!)
            </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/63cbQdzd_oo" title="Hellscape Radio, Vol. 1 (Hosted by ANJU Online!)" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio Vol. 1</strong><br/>
            (Hosted by ANJU Online!)
            </p>

        </div>
      </>
    );
  };
  export default ArchiveHellscapeRadioStatic;